module.exports = __webpack_public_path__ + "static/media/red-small.d0dc07e2.svg";